import styled, { css } from 'styled-components';
import { Chart } from '../../../../ui/atoms/CircularStats/style';
import { StyledModal } from '../../../../ui/atoms/Modals/style';

const gridThreeCol = css`
  display: grid;
  gap: 28px;
  grid-template-columns: 1fr 1fr 1fr;
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 24px;
  margin-bottom: 16px;

  @media ${(props) => props.theme.device.tabletL} {
    display: flex;
    flex-direction: column;
    row-gap: 32px;
    margin-bottom: 24px;
  }
`;

export const InfoBox = styled.div`
  gap: 32px;
  padding: 20px 24px;
  background-color: ${({ theme }) => theme.colors.bgBox};
  border-radius: 8px;
`;

export const InfoBoxMobile = styled.div`
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.bgBox};
  border-radius: 8px;
  display: flex;
  column-gap: 24px;
`;

export const CardsGrid = styled.div`
  ${gridThreeCol}
  margin-top: 28px;
  padding-bottom: 48px;

  @media ${(props) => props.theme.device.tabletL} {
    grid-template-columns: 1fr 1fr;
    padding-bottom: 48px;
    margin-bottom: 0;

    .span-2 {
      grid-column-end: span 2;
    }
  }

  @media ${(props) => props.theme.device.mobileL} {
    display: flex;
    flex-direction: column;
    row-gap: 24px;
  }
`;

export const Card = styled.div`
  padding: 16px;
  border-radius: 12px;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);

  &.large {
    grid-column-end: span 2;
  }

  .filters-wrapper {
    margin-top: 8px;
    display: flex;
    align-items: center;
    column-gap: 16px;
  }

  @media ${(props) => props.theme.device.mobileL} {
    display: flex;
    flex-direction: column;

    .filters-wrapper {
      margin-top: 16px;
      margin-bottom: 32px;
      flex-direction: column;
      align-items: flex-start;
      row-gap: 8px;
    }
  }

  .barchart-wrapper {
    height: 250px;
    margin-block: 16px;

    > div {
      height: inherit;
    }

    @media ${(props) => props.theme.device.mobileL} {
      margin-top: 0;
    }
  }
`;

export const CardInner = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 16px;

  @media ${(props) => props.theme.device.tabletL} {
    row-gap: 24px;
  }
`;

export const TutorChartWrapper = styled.div`
  //? the chart (excluding @mobile)
  > [size='145'] {
    justify-content: center;
    column-gap: 16px;

    > div {
      width: 170px;
    }
  }
`;

export const TextAndInputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;

  @media ${(props) => props.theme.device.mobileL} {
    display: flex;
    flex-direction: column-reverse;
    row-gap: 16px;
    align-items: start;
    margin-bottom: 16px;
  }

  & > * {
    max-width: 60%;
  }
`;

export const Column = styled.div.withConfig({
  shouldForwardProp: (prop) => !['rowGap'].includes(prop),
})`
  display: flex;
  flex-direction: column;
  row-gap: ${({ rowGap }) => rowGap}px;
`;

export const SelectWrapper = styled.div`
  margin-top: 24px;
  max-width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media ${(props) => props.theme.device.mobileL} {
    display: flex;
    margin-bottom: 40px;
  }
`;

//* accesses chart
export const LargeChartGrid = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  gap: 16px 48px;

  @media ${(props) => props.theme.device.mobileL} {
    display: flex;
    flex-direction: column;
    row-gap: 16px;
  }

  canvas {
    max-height: 200px;
  }

  .info-box {
    border-radius: 8px;
    background: rgba(178, 229, 255, 0.37);
    padding: 22px 19px 21px 19px;
    height: 140px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    > * {
      max-width: 140px;
      text-align: center;
    }
  }
`;

export const TextAndFilter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 16px;

  @media ${(props) => props.theme.device.tabletL} {
    grid-column: 1 / -1;
  }

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column-reverse;
    align-items: flex-start;
    row-gap: 16px;
  }
`;

export const EmptyElement = styled.div`
  @media ${(props) => props.theme.device.tabletL} {
    display: none;
  }
`;

export const ChartsWrapper = styled.div`
  display: flex;
  margin-bottom: 32px;

  .chart-container {
    margin-top: 24px;
    min-height: 145px;
    border-right: 2px dashed ${({ theme }) => theme.colors.border};
    margin-right: 36px;
    padding-right: 36px;

    > div {
      max-width: calc(100% - 130px - 16px * 2 - 16px);
      //? 130px (chart) 16px*2 (bubbles) 16px (gap)
    }

    &.last {
      margin-right: 0;
      padding-right: 0;
      border-right: none;
    }
  }
  .chart-wrapper {
    position: relative;
    right: 80px;
  }

  @media ${(props) => props.theme.device.tabletL} {
    flex-direction: column;

    .chart-container {
      margin-right: 0;
      padding-right: 0;
      border: none;
    }
  }

  @media ${(props) => props.theme.device.mobileL} {
    order: 2;

    .chart-container {
      min-height: 300px;
      flex-direction: column;
      align-items: flex-start;

      > div {
        max-width: unset;
      }
    }

    .chart-wrapper {
      position: relative;
      left: 50%;
      height: 190px;
    }

    ${Chart} {
      top: unset;
      bottom: unset;
      right: unset;
      width: unset;
      transform: translate(-50%, 0%);
    }
  }
`;

export const RefreshAndLegend = styled.div`
  display: flex;
  justify-content: space-between;

  @media ${(props) => props.theme.device.tabletL} {
    flex-direction: column-reverse;
    row-gap: 24px;
  }
`;

export const ChartLegend = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 24px;
  row-gap: 8px;

  @media ${(props) => props.theme.device.mobileL} {
    order: 1;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  }
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
`;

export const ColorBox = styled.div`
  width: 20px;
  height: 11px;
  flex-shrink: 0;
  border-radius: 3px;
  background: ${({ color }) => color};
  //? prevent background from being ignored @print
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
`;

export const DataAndLegend = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 24px;

  @media ${(props) => props.theme.device.tabletL} {
    flex-direction: column;
    align-items: center;
    row-gap: 16px;
  }

  @media ${(props) => props.theme.device.mobileL} {
    align-items: stretch;
    margin-bottom: 16px;
  }
`;

export const FullDataBox = styled.div`
  padding: 6px 8px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.bgBox};
  display: flex;
  align-items: center;

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
  }
`;

export const DataBit = styled.div`
  display: flex;
  align-items: baseline;
  column-gap: 6px;

  &:not(:last-child)::after {
    content: '|';
    padding-right: 6px;
  }

  @media ${(props) => props.theme.device.mobileL} {
    &:not(:last-child)::after {
      display: none;
    }
  }
`;

export const CourseFiltersWrapper = styled.div`
  display: flex;
  column-gap: 16px;

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
    row-gap: 8px;
  }
`;

export const ModalsWrapper = styled.div`
  ${StyledModal}:modal {
    height: auto;
  }
`;
